/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import VueSweetalert2 from 'vue-sweetalert2';
import Store from './store/index';
import translations from '../translations/index';
import Assets from '../plugins/assets';
import Paths from '../plugins/paths';
import AOS from '../plugins/aos';
import AdivareLetterMain from './components/letter/letter-main.vue';
import AdivareCancellationReviewMain from './components/cancellation-review/cancellation-review-main.vue';
import AdivareCancellationReview from './components/cancellation-review/cancellation-review.vue';
import AdivareAnonymousCancellationReview from './components/anonymous-review/anonymous-review-form.vue';

const app = createApp({});

app.use(VueSweetalert2);
app.use(translations);
app.use(Assets, JS_ASSET ?? {});
app.use(Paths);
app.use(Store);
app.use(AOS);
app.use(VueLazyload, {
  lazyComponent: true,
});

app.component('adivare-letter', AdivareLetterMain);
app.component('adivare-cancellation-review-main', AdivareCancellationReviewMain);
app.component('adivare-cancellation-review', AdivareCancellationReview);
app.component('adivare-anonymous-cancellation-review', AdivareAnonymousCancellationReview);
app.mount('#vue-mount');
